import * as React from 'react';

// Component
import LoginByPasswordFooter from '../../../LoginByPasswordFooter';
import AltLoginLink from '../../../AltLoginLink';

// HoCs & Utils
import { WithUserWebViewProps } from '@shopee-user/with-web-view';
import { useResponsiveLayout, Layout } from '@shopee-user/layout-responsive';
import styles from './style.scss';

const DO_NOTHING = () => {};

function Footer() {
  const { layout } = useResponsiveLayout();

  const DesktopAltLoginLink = layout === Layout.Desktop && <AltLoginLink />;
  return (
    <div className={styles.footerContainer}>
      {DesktopAltLoginLink}
      <LoginByPasswordFooter
        showToast={
          // SPX does not require this function
          DO_NOTHING
        }
        webViewFetchToBDataFromNative={
          // SPX does not require this function
          (DO_NOTHING as unknown) as WithUserWebViewProps['webViewFetchToBDataFromNative']
        }
      />
    </div>
  );
}

export default Footer;
